export default __webpack_public_path__ + "static/media/ca.026adb08.svg";